module.exports = __webpack_public_path__ + "static/20230619_093-f3e6031a397012ea30609c2f67407e7c.jpg";